import { formatPrice } from "../../utils/utility";

interface StatsCardProps {
  title: string;
  value: string | number;
  // A solid dot colour, e.g. "bg-emerald-500" — the only splash of colour per KPI.
  color: string;
  isCurrency?: boolean;
}

// A single KPI: tiny labelled dot, then a big confident number. No box of its
// own — it lives inside the shared stats panel, separated only by whitespace.
export function StatsCard({ title, value, color, isCurrency = false }: StatsCardProps) {
  const displayValue = isCurrency ? formatPrice(Number(value)) : value;

  return (
    <div className="min-w-0">
      <div className="flex items-center gap-2 mb-2.5">
        <span className={`w-1.5 h-1.5 rounded-full ${color}`} />
        <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400 truncate">
          {title}
        </p>
      </div>
      <p className="text-[26px] md:text-[32px] leading-none font-semibold text-gray-900 tracking-tight truncate">
        {displayValue}
      </p>
    </div>
  );
}
